import { ProConfigProvider } from '@ant-design/pro-components';
import { useMemo } from 'react';
import DateTimeText from '@/components/DateTimeText';
import {
  TimezoneDatePicker,
  TimezoneRangePicker,
} from '@/components/TimezoneDatePicker';
import { useTimezone } from '@/hooks/useTimezone';

export default function TimezoneProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { mode } = useTimezone();

  const valueTypeMap = useMemo(
    () => ({
      dateTime: {
        render: (text: unknown) => <DateTimeText value={text} />,
        renderFormItem: (_: unknown, props: any) => (
          <TimezoneDatePicker
            showTime
            style={{ width: '100%' }}
            {...props.fieldProps}
            value={props.value}
            onChange={(nextValue) => props.onChange?.(nextValue)}
          />
        ),
      },
      dateTimeRange: {
        render: (text: unknown) => {
          if (!text || !Array.isArray(text)) {
            return <>-</>;
          }
          const [start, end] = text;
          return (
            <>
              <DateTimeText value={start} /> ~ <DateTimeText value={end} />
            </>
          );
        },
        renderFormItem: (_: unknown, props: any) => (
          <TimezoneRangePicker
            showTime
            {...props.fieldProps}
            value={props.value}
            onChange={(nextValue) => props.onChange?.(nextValue)}
          />
        ),
      },
    }),
    [mode],
  );

  return (
    <ProConfigProvider valueTypeMap={valueTypeMap}>{children}</ProConfigProvider>
  );
}
